import React from "react";

const About = (props) => {
	// const [btnText, setbtnText] = useState("Enable Dark mode");

	// const handleClick = () => {
	// 	// if (mode === lightModeStyle) { // it has some problem in 2nd iteration
	// 	if (btnText === "Enable Dark mode") {
	// 		setMode(darkModeStyle)
	// 		setbtnText("Enable Light mode")
	// 	} else {
	// 		setMode(lightModeStyle)
	// 		setbtnText("Enable Dark mode")
	// 	}
	// }

	// to change mode

	let style = {
		color: props.mode === "dark" ? "white" : "black",
		backgroundColor: props.mode === "dark" ? "rgb(39 43 47)" : "white",
		borderColor: props.mode === "dark" ? "white" : "black",
		borderWidth: "1px",
		borderStyle: "solid",
	};

	return (
		<>
			{/* <div className="right-container mb-3">
				<button type="button"
					className="btn btn-dark float-right"
					onClick={handleClick}
				>
					{btnText}
				</button>
			</div> */}
			<div
				className="accordion container md-container-fluid w-50"
				id="accordionExample"
			>
				<h1 className="px-2">About This App</h1>
				<div className="accordion-item" style={style}>
					<h2 className="accordion-header" id="headingOne">
						<button
							style={style}
							className="accordion-button"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseOne"
							aria-expanded="true"
							aria-controls="collapseOne"
						>
							Analyze your text
						</button>
					</h2>
					<div
						id="collapseOne"
						className="accordion-collapse collapse show"
						aria-labelledby="headingOne"
						data-bs-parent="#accordionExample"
					>
						<div className="accordion-body">
							<p>
								TextUtils is a Word counter, Character counter, change Uppercase to lowercase and lowercase to uppercase. This app can also be used to remove extra spaces from large texts.
							</p>
						</div>
					</div>
				</div>
				<div className="accordion-item" style={style}>
					<h2 className="accordion-header" id="headingTwo">
						<button
							style={style}
							className="accordion-button collapsed"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseTwo"
							aria-expanded="false"
							aria-controls="collapseTwo"
						>
							Free to use
						</button>
					</h2>
					<div
						id="collapseTwo"
						className="accordion-collapse collapse"
						aria-labelledby="headingTwo"
						data-bs-parent="#accordionExample"
					>
						<div className="accordion-body">
							<p>
								<strong>
									This is a free to use app and no charges are collected to use
									this site.
								</strong>
							</p>
						</div>
					</div>
				</div>
				<div className="accordion-item" style={style}>
					<h2 className="accordion-header" id="headingThree">
						<button
							style={style}
							className="accordion-button collapsed"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseThree"
							aria-expanded="false"
							aria-controls="collapseThree"
						>
							Multi Device compatible
						</button>
					</h2>
					<div
						id="collapseThree"
						className="accordion-collapse collapse"
						aria-labelledby="headingThree"
						data-bs-parent="#accordionExample"
					>
						<div className="accordion-body">
							<p>
								This is a multi device compatible app which can be used on a
								mobile phone or a large screen device like a destop for your
								daily needs.
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default About;
